import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IGroupedProducts, IProducts } from '../models/products.model';

export const groupedProductsFromSomeoneElseFeatureKey = 'groupedProductsFromSomeoneElse';

export interface GroupedProductsFromSomeoneElseState {
  loadGroupedProductsFromSomeoneElse: string;
  loadGroupedProductsFromSomeoneElseResponse: IGroupedProducts[];
  loadGroupedProductsFromSomeoneElseFailure: Error | any;
}

export const initialState: GroupedProductsFromSomeoneElseState = {
  loadGroupedProductsFromSomeoneElse: undefined,
  loadGroupedProductsFromSomeoneElseResponse: undefined,
  loadGroupedProductsFromSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadGroupedProductsFromSomeoneElse, (state, action) => ({
    ...state,
    loadGroupedProductsFromSomeoneElse: action.request
  })),
  on(actions.loadGroupedProductsFromSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadGroupedProductsFromSomeoneElseResponse: action.response
  })),
  on(actions.loadGroupedProductsFromSomeoneElseFailure, (state, action) => ({
    ...state,
    loadGroupedProductsFromSomeoneElseFailure: action.error
  }))
);

export const getGroupedProductsFromSomeoneElseResponse = (state: GroupedProductsFromSomeoneElseState) =>
  state.loadGroupedProductsFromSomeoneElseResponse;
